import {Component, OnInit, ViewChild} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {CentreOption} from "../../../../interfaces/Centres";
import {MatTableDataSource} from "@angular/material/table";
import {FormControl} from "@angular/forms";
import {UserRole} from "../../../../components/rename/add-user-role/add-user-role.component";
import {CentreService} from "../../../../services/centre.service";
import {Router} from "@angular/router";
import {DatePipe} from "@angular/common";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {EducationService} from "../../education.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {LogService} from "../../../../services/log.service";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {EmployeeService} from "../../../../services/employee.service";
import {MatSelectChange} from "@angular/material/select";
import {ViewEducationIndividualComponent} from "../view-education-individual/view-education-individual.component";
import {AddIdividualEducationComponent} from "../add-idividual-education/add-idividual-education.component";
import {EditIndividualEducationComponent} from "../edit-individual-education/edit-individual-education.component";
import {Timestamp} from "@angular/fire/firestore";
import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";
import {LogVerifyDialogComponent} from "../../../reports/log-verify-dialog/log-verify-dialog.component";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {ViewEducationHighlightComponent} from "../view-education-highlight/view-education-highlight.component";
import {ViewFollowUpEducationComponent} from "../view-follow-up-education/view-follow-up-education.component";
import {FinancialYearService} from "../../../../services/financial-year.service";

@Component({
  selector: 'app-education-highlight',
  templateUrl: './education-highlight.component.html',
  styleUrls: ['./education-highlight.component.scss'],
  animations: [
    trigger('detailExpand', [
      transition(':enter', [
        style({ height: '0px', opacity: 0 }),
        animate('220ms ease', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        animate('180ms ease', style({ height: '0px', opacity: 0 })),
      ]),
    ]),
  ],
})
export class EducationHighlightComponent implements OnInit {
  mAttendance: string | null = null
  mTeacher: string | null = null
  mSession: string|null=null
  mVolunteer='All'
  // displayedColumns: string[] = ['sr.no','source','childName', 'centreName', 'sessionDate', 'sessionType', 'present', 'submittedBy', 'createdAt', 'expand'];
  displayedColumns: string[] = [
    'sr.no',
    'source',
    'childName',
    'centreName',
    'sessionDate',
    'sessionType',
    'submittedBy',
    'action',
  ];
  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;
  start: Date | undefined
  end: Date | undefined
  centres$!: Observable<CentreOption[]>;
  userData: any
  mAllData: any[] = []
  mFilteredData: any[] = []
  dataSource = new MatTableDataSource(this.mAllData);
  SelectCentre = new FormControl('')
  selectedCentre = 'All'
  permissions = JSON.parse(localStorage.getItem('permissions')!) as UserRole[]
  education = this.permissions.filter((x) => x.functionName == 'Education')
  teachers$: Observable<any[]>
  userRole = ''
  isLoading = false;  // New loading flag
  sessionTypes=['Baseline Assessment','Discharge Assessment','Intermediate Assessment','Rapport Building','Regular Study'];
  volunteers$:Observable<any>

  /** Currently expanded row — null when nothing is expanded */
  expandedElement: any = null;

  /** Predicate for the detail *matRowDef — only renders the row when expanded */
  isExpandedRow = (_index: number, row: any) => this.expandedElement === row;
  constructor(private readonly centreService: CentreService,
              private readonly router: Router,
              private datePipe: DatePipe,
              private readonly mSnackbar: MatSnackBar,
              private readonly mDialog: MatDialog,
              private educationService: EducationService,
              private readonly _snackBar: MatSnackBar,
              private readonly matDialog: MatDialog,
              private  readonly mFirestore:AngularFirestore,
              private readonly mLogService: LogService,
              private  readonly mDatabase:AngularFireDatabase,
              private readonly mEmployeeService: EmployeeService,
              private readonly financialYearService: FinancialYearService
  ) {
    this.teachers$ = this.mEmployeeService.getTeachers()
    this.userData = JSON.parse(localStorage.getItem('userData')!)
    const sortByName = map((centres: any[]) => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())));
    if (this.userData.role == 'Centre') {
      this.centres$ = centreService.getSortedCenterListByRole(this.userData.centreCode).pipe(sortByName)
    } else if (this.userData.role != 'Centre') {
      this.centres$ = centreService.getAllCentres().pipe(sortByName)
    }
    const userData = JSON.parse(localStorage.getItem('userData')!)
    this.userRole = userData?.role
    if (this.userRole == "Centre Manager" || "Developer") {
      this.displayedColumns = ['sr.no','source','childName', 'centreName', 'sessionDate', 'sessionType', 'submittedBy', 'action',];
    }
    this.volunteers$ = this.mDatabase.list('types/Volunteers').valueChanges()
  }

  clearAll() {
    // Reset date range back to the current financial year
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.start = fy.startDate;
    this.end = fy.endDate;
    this.mAttendance = null
    this.mTeacher = null
    this.mSession = null
    // Reset selected centre
    this.selectedCentre = 'All';
    this.SelectCentre.setValue('');

    // Clear education data
    this.mAllData = [];
    this.dataSource.data = [];

    // Reset pagination and sorting
    this.paginator?.firstPage();


    // Optionally, reset any other form controls or variables here
  }
// 9960626509
  ngOnInit(): void {
    // Pre-fill the date range with the current financial year (search still requires an explicit click)
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.start = fy.startDate;
    this.end = fy.endDate;
  }
  fetchByCenter($event: MatSelectChange) {
    this.selectedCentre = $event.value
    console.log('FETCH CENTER SELECTED IN EDUCATION')

    // this.educationService.getEducation($event.value).subscribe(re => {
    //     this.educationData = re
    //     this.dataSource = new MatTableDataSource(this.educationData);
    //     this.dataSource.sort = this.sort!;
    //     this.dataSource.paginator = this.paginator!;
    //     console.log(this.dataSource.data)
    // })
  }

  search() {
    this.isLoading = true;

    const individualPromise = this.educationService.individualHighlights(
      this.selectedCentre,
      this.start,
      this.end,
      this.mAttendance,
      null,        // teacher filtered client-side
      this.mSession
    );

    const followUpPromise = this.educationService.getFollowUpHighlights(
      this.selectedCentre,
      this.start,
      this.end,
      this.mSession
    );

    Promise.all([individualPromise, followUpPromise]).then(([indRes, fuRes]) => {

      // Individual highlights
      let individualData: any[] = indRes.docs.map(doc => ({
        id: doc.id,
        ...doc.data() as any,
        _source: 'Individual'
      }));

      // Follow-up highlights — normalize `date` → `sessionDate`
      let followUpData: any[] = fuRes.docs.map(doc => {
        const d = doc.data() as any;
        return {
          id: doc.id,
          ...d,
          sessionDate: d.date,    // map date field to sessionDate for unified table
          _source: 'Follow-Up'
        };
      });

      // Apply teacher filter client-side
      if (this.mTeacher && this.mTeacher !== 'All') {
        individualData = individualData.filter((x: any) => x.submittedBy === this.mTeacher);
        followUpData   = followUpData.filter((x: any) => x.submittedBy === this.mTeacher);
      }

      // Merge and sort by sessionDate descending
      this.mFilteredData = [...individualData, ...followUpData].sort((a, b) => {
        const dateA = a.sessionDate?.toDate?.() ?? new Date(0);
        const dateB = b.sessionDate?.toDate?.() ?? new Date(0);
        return dateB.getTime() - dateA.getTime();
      });

      this.dataSource = new MatTableDataSource(this.mFilteredData);
      this.dataSource.sort = this.sort!;
      this.dataSource.paginator = this.paginator!;
      this.isLoading = false;

    }).catch(err => {
      console.error('Search error:', err);
      this.isLoading = false;
    });
  }
  getDate(date: Date): any {
    let d = (date as unknown as Timestamp).toDate()
    let datePipeString = this.datePipe.transform(d, 'dd-MMM-yyyy');
    return datePipeString
  }

  getDateandTime(date: Date): any {
    let d = (date as unknown as Timestamp).toDate()
    let datePipeString = this.datePipe.transform(d, 'dd-MMM-yyyy h:mm a ');
    return datePipeString
  }

  getTime(date: Date): any {
    let datePipeString: string | null = "NA"

    if (date != null) {
      let d = (date as unknown as Timestamp).toDate()
      datePipeString = this.datePipe.transform(d, "h:mm a")
      // console.log('DATEPIPE STRING',datePipeString )

      return datePipeString
    }
  }

  viewDialog(element: any) {
    if (element._source === 'Follow-Up') {
      this.matDialog.open(ViewFollowUpEducationComponent, {
        data: element,
        width: '800%',
        autoFocus: false,
        height: '90%'
      });
    } else {
      this.matDialog.open(ViewEducationHighlightComponent, {
        data: element,
        width: '800%',
        autoFocus: false,
        height: '90%'
      });
    }
    let activity = {
      date: new Date().getTime(),
      section: 'Individual Education',
      action: 'View',
      description: `${element._source || 'Education'} Highlight View by user`,
      currentIp: localStorage.getItem('currentip')!
    };
    this.mLogService.addLog(activity);
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  getTooltip(element: any): string {
    const reviewRemark = element?.reviewRemark || 'No review remark';
    const reviewedBy = element?.reviewedBy || 'Unknown reviewer';
    const status = element?.status || 'Pending';

    return `${reviewRemark}\nReviewed By: ${reviewedBy}`;
  }


  getPresent(element: any) {
    let st = 'A'
    if (element.present == "Present") st = 'P'
    return st
  }

  private filterWithDate(data:any,date: Date, date2: Date) {
    this.mFilteredData = data.filter((x: any) => x.sessionDate.toDate() >= date && x.sessionDate.toDate() <= date2)
  }

  filterData() {
    this.mFilteredData = this.mAllData.filter(x =>
      (this.mTeacher === 'All' || this.mTeacher === null || x.submittedBy === this.mTeacher) &&
      (this.mSession === 'All' || this.mSession === null || x.sessionType === this.mSession)
    );

    console.log('after filtering: teacher', this.mTeacher);
    console.log('after filtering: session', this.mSession);
    this.dataSource.data = this.mFilteredData;
  }

  downloadExcel() {
    const tableData = this.dataSource.filteredData;

    if (!tableData || tableData.length === 0) {
      alert('No data available to download');
      return;
    }

    let excelContent = `
    <table border="1">
      <tr>
        <th>Sr.No</th>
        <th>Source</th>
        <th>Name</th>
        <th>Centre</th>
        <th>Session Date</th>
        <th>Session Type</th>
        <th>Attendance</th>
        <th>Teacher</th>
        <th>Created At</th>
        <th>Status</th>
      </tr>
  `;

    tableData.forEach((x: any, index: number) => {
      excelContent += `
      <tr>
        <td>${index + 1}</td>
        <td>${x._source ?? 'Individual'}</td>
        <td>${x.childName ?? '-'}</td>
        <td>${x.centreName ?? '-'}</td>
        <td>${x.sessionDate ? this.getDate(x.sessionDate) : '-'}</td>
        <td>${x.sessionType ?? '-'}</td>
        <td>${x._source === 'Follow-Up' ? 'N/A' : this.getPresent(x)}</td>
        <td>${x.submittedBy ?? '-'}</td>
        <td>${x.createdAt ? this.getDateandTime(x.createdAt) : '-'}</td>
        <td>${x.status ?? 'Pending'}</td>
      </tr>
    `;
    });

    excelContent += `</table>`;

    const blob = new Blob(
      ['\ufeff' + excelContent],
      { type: 'application/vnd.ms-excel;charset=utf-8;' }
    );

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `Education_Highlights_${Date.now()}.xls`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }




  /**
   * Toggle the highlight status — routes to the correct service method based on source.
   */
  protected toggleHighlight(element: any) {
    const serviceCall = element._source === 'Follow-Up'
      ? this.educationService.toggleFollowUpHighlight(element)
      : this.educationService.toggleIndividualSessionHighlight(element);

    serviceCall
      .then(() => {
        console.log('Highlight toggled successfully');
        let activity = {
          date: new Date().getTime(),
          section: element._source === 'Follow-Up' ? 'Follow Up Assessment' : 'Individual Education',
          action: 'Toggle Highlight',
          description: `Session for ${element.childCode || element.childName} ${element.isHighlight ? 'highlighted' : 'unhighlighted'} by user`,
          currentIp: localStorage.getItem('currentip')!
        };
        this.mLogService.addLog(activity);
      })
      .catch(err => {
        console.error('Error toggling highlight:', err);
        element.isHighlight = !element.isHighlight; // revert on error
      });
    element.isHighlight = !element.isHighlight;

  }
  protected readonly PermissionType = PermissionType;

  /** Toggle expandable detail panel for a row */
  toggleExpand(row: any): void {
    this.expandedElement = this.expandedElement === row ? null : row;
  }
}
